/**
 * What the Quest board shows around the Studio unlock.
 *
 * Two rules, both learned the hard way:
 *
 * 1. The unlock is spent by ACCEPTING it, never by opening the modal. Telling
 *    the server on button-press meant "Later" silently consumed the moment.
 * 2. While the unlock is pending it is the only thing in the column. The Mystic
 *    quests below it cannot be started until the Studio exists, and a wall of
 *    them buries the single action the seeker came for.
 */
export function unlockState (s) {
  const unlocked = !!(s && s.unlocked)
  const accepted = !!(s && s.accepted)
  const pending = unlocked && !accepted
  return {
    // Offered until accepted. Pressing it accepts.
    showUnlock: pending,
    // No intermediate confirmation. The card already says the Studio is open;
    // a modal repeating it sat between wanting this and the page that asks for
    // 2,000 carats, which is a speed bump rather than a celebration.
    needsConfirmModal: false,
    // Hidden only while the unlock is pending — before the path is walked they
    // are the preview of what is coming, and afterwards they are the work.
    showMysticQuests: !pending,
  }
}

/**
 * The Studio entry's price as a goal (quest journey 2026-10-27), never a
 * shortfall: "1,240 of 2,000 ✦ · keep showing up, or add carats".
 */
export function seatGoalLine (balance, price) {
  const p = Math.round(Number(price) || 0)
  if (!p) return ''
  const b = Math.max(0, Math.round(Number(balance) || 0))
  return `${b.toLocaleString('en-US')} of ${p.toLocaleString('en-US')} ✦ · keep showing up, or add carats`
}
